export default function ListPageShell({ children }) {
  return (
    <div className="min-h-full bg-gradient-to-b from-gray-50/60 via-white to-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 flex flex-col gap-6">
        {children}
      </div>
    </div>
  );
}
